import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NamedLink, TopBanner } from '../../components';
import { hasAutoGeneratedEmail } from '../../util/userHelpers';

import css from './TeliaEmailBanner.module.css';

/**
 * TeliaEmailBanner shows a persistent warning banner for users with auto-generated Telia emails.
 * These users cannot receive email notifications and should update their email address.
 */
const TeliaEmailBanner = props => {
  const { currentUser } = props;

  // Only show banner if user has auto-generated Telia email
  if (!hasAutoGeneratedEmail(currentUser)) {
    return null;
  }

  return (
    <TopBanner type="warning" dismissible={false} testId="TeliaEmailBanner">
      <span className={css.message}>
        <FormattedMessage
          id="TeliaEmailBanner.message"
          defaultMessage="⚠️ Päivitä sähköpostiosoitteesi vastaanottaaksesi ilmoituksia yritysprofiilisi kyselyistä."
        />
      </span>
      <NamedLink name="ContactDetailsPage" className={css.link}>
        <FormattedMessage
          id="TeliaEmailBanner.updateButton"
          defaultMessage="Päivitä nyt"
        />
      </NamedLink>
    </TopBanner>
  );
};

export default TeliaEmailBanner;
